import React, { useState } from 'react';
import { Table, Input, Checkbox, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const options = [
  { label: 'Anonimos', value: 'anonimos' },
  { label: 'Registrados', value: 'registrados' },
  { label: 'Suscriptores', value: 'suscriptores' },
];

const Step1 = ({ value, onChange }) => {
  const [search, setSearch] = useState('');

  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(search.toLowerCase())
  );

  
  const columns = [
    {
      title: 'Seleccionar',
      width: 50, 
      render: (text, record) => (
        <Checkbox
          checked={value.includes(record.value)}
          onChange={(e) => {
            const newValue = e.target.checked
              ? [...value, record.value]
              : value.filter(val => val !== record.value);
            onChange(newValue);
          }}
        />
      ),
    },
    {
      title: 'Opciones',
      dataIndex: 'label',
      key: 'label',
    },
  ];

  return (
    <div>
      <div className='text-muted mb-2'>Selecciona el tipo de usuario</div>
      <Space style={{ marginBottom: 16 }}>        
        <Input
          placeholder="Buscar opciones..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: '200px' }}
        />
        <SearchOutlined style={{ fontSize: 16 }} />
      </Space>
      <Table
        rowKey="value"
        columns={columns}
        dataSource={filteredOptions}
        size="small"
        pagination={false} 
        onRow={(record) => ({
          onClick: () => {
            const newValue = value.includes(record.value)
              ? value.filter(val => val !== record.value)
              : [...value, record.value];
            onChange(newValue);
          },
        })}
      />
    </div>
  );
};

export default Step1;
